import { matterPaths } from '@/routing/paths'

export type LrrViewerMetadata = {
  s3_path: string
}

export type LrrViewerContext = {
  matterId?: string | null
}

/**
 * Builds the URL for the standalone LRR reference viewer.
 *
 * @param metadata - Reference metadata containing s3_path
 * @param context - Optional context; when matterId is present uses matter-first path
 * @returns Standalone viewer URL, or null if s3_path is missing
 */
export function buildLrrStandaloneViewerURL(metadata: LrrViewerMetadata, context?: LrrViewerContext): string | null {
  if (!metadata.s3_path) return null

  const matterId = typeof context?.matterId === 'string' && context.matterId.trim().length > 0 ? context.matterId.trim() : null

  return matterPaths.referenceViewer.lrr(matterId, encodeURIComponent(metadata.s3_path))
}
